// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17gCK","field":"styles_field__IOxOm","fieldCol":"styles_fieldCol__2DVOz","diffCol":"styles_diffCol__1CZY8","diff":"styles_diff__1vICs"};